const requestInfoHeaderListColumns = [
// 请求头
{
  title: '标签',
  dataIndex: 'header_name',
  key: 'header_name'
}, {
  title: '内容',
  dataIndex: 'header_value',
  key: 'header_value'
}];
const requestInfoParamsListColumns = [
// 请求参数
{
  title: '名称',
  dataIndex: 'param_key',
  key: 'param_key'
}, {
  title: '类型',
  dataIndex: 'param_type',
  key: 'param_type'
}, {
  title: '是否必填',
  dataIndex: 'param_not_null',
  key: 'param_not_null',
  scopedSlots: {
    customRender: 'param_not_null'
  },
  width: 90,
  align: 'center'
}, {
  title: '示例',
  dataIndex: 'param_range',
  key: 'param_range'
}, {
  title: '描述',
  dataIndex: 'param_description',
  key: 'param_description'
}];
const responseInfoParamsListColumns = [
// 返回
{
  title: '名称',
  dataIndex: 'param_key',
  key: 'param_key'
}, {
  title: '类型',
  dataIndex: 'param_type',
  key: 'param_type'
}, {
  title: '描述',
  dataIndex: 'param_description',
  key: 'param_description'
}];
const statusCodeListColumns = [
// 状态
{
  title: '状态码',
  dataIndex: 'code',
  key: 'code'
}, {
  title: '状态描述',
  dataIndex: 'description',
  key: 'description'
}];
const urlParamsColumns = [
// 调试API请求参数
{
  title: '参数名',
  dataIndex: 'param_key',
  key: 'param_key'
}, {
  title: '参数值',
  dataIndex: 'param_range',
  key: 'param_range',
  scopedSlots: {
    customRender: 'param_range'
  }
}];
export { requestInfoHeaderListColumns, responseInfoParamsListColumns, requestInfoParamsListColumns, statusCodeListColumns, urlParamsColumns };